<template>
  <div class="p-grid">
    <div class="p-col-12">
      <Card>
        <template #title>Instruções para a importação</template>
        <template #content>
          <a
            :href="exampleFileExcel"
            target="_self"
            class="p-mr-3"
            style="display: inline-flex"
          >
            <IconExcel :width="18" :height="18" class="p-mr-1"></IconExcel>
            Download do Modelo para Excel
          </a>
          <a :href="exampleFileCsv" target="_self" style="display: inline-flex">
            <IconCsv
              :width="18"
              :height="18"
              :fill="'#868686'"
              class="p-mr-1"
            ></IconCsv>
            Download do Modelo para CSV
          </a>
          <BovineImportInstruction></BovineImportInstruction>
        </template>
        <template #footer>
          <div class="p-grid p-jc-between">
            <div
              style="
                padding-left: 8px;
                display: inline-flex;
                align-items: center;
              "
            >
              <AppUploadButton
                label="Importar arquivo"
                accept=".csv,.xlsx"
                @upload="onUpload($event)"
                :multilple="false"
              ></AppUploadButton>
              <div class="p-ml-4">
                <Checkbox
                  name="dontShow"
                  v-model="preferences.bovineImport.ignoreInactive"
                  :binary="true"
                />
                <label for="dontShow"> Ignorar bovinos inativos </label>
              </div>
            </div>
            <div style="padding-right: 8px">
              <router-link tag="span" :to="cancelLink">
                <Button label="Cancelar" class="p-button-outlined p-mr-2" />
              </router-link>
              <AppButton
                label="Salvar"
                @click="save()"
                :loading="loadingSave"
              />
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12">
      <Card>
        <template #title>
          <div class="p-grid p-jc-between">
            <div class="p-col-6">Bovinos importados</div>
            <div class="p-col-6 p-text-right">
              <Button
                label="Adicionar Linha"
                class="p-button-outlined"
                @click="$refs.importTable.addEmptyItem()"
              />
            </div>
          </div>
        </template>
        <template #content>
          <AppSkeletonCardTable v-if="loading"></AppSkeletonCardTable>
          <BovineImportTable
            v-else
            ref="importTable"
            v-model:rows="rows"
            v-model:loading="loading"
            :serviceId="$route.query.serviceId"
          ></BovineImportTable>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import IconCsv from '../../components/icon/IconCsv.vue';
import IconExcel from '../../components/icon/IconExcel.vue';
import { BovineApi, PreferenceApi } from '../../services/api';
import BovineImportInstruction from './components/BovineImportInstruction.vue';
import BovineImportTable from './components/BovineImportTable.vue';

export default {
  name: 'BovineImport',
  components: {
    BovineImportInstruction,
    BovineImportTable,
    IconExcel,
    IconCsv,
  },
  data() {
    return {
      rows: [],
      loading: false,
      loadingSave: false,
      preferences: {
        bovineImport: { ignoreInactive: true },
      },
    };
  },
  computed: {
    exampleFileExcel() {
      return this.$route.query.serviceId
        ? '../../../../importacao-servico.xlsx'
        : '../../../../importacao-bovinos.xlsx';
    },
    exampleFileCsv() {
      return this.$route.query.serviceId
        ? '../../../../importacao-servico.csv'
        : '../../../../importacao-bovinos.csv';
    },
    cancelLink() {
      if (this.$route.query.serviceId) {
        return {
          name: 'service.edit',
          params: { id: this.$route.query.serviceId },
        };
      }
      if (this.$route.query.sale) {
        return {
          name: 'sale.create.bovines',
          params: {
            bovineImport: '[]',
          },
        };
      }
      return { name: 'bovine.list' };
    },
  },
  async created() {
    await this.loadPreferences();
  },
  methods: {
    getApiOptions() {
      return { accessToken: this.$route.query.accessToken };
    },
    async loadPreferences() {
      try {
        this.preferences = await PreferenceApi.fetch(this.getApiOptions());
      } catch (error) {
        console.error(error);
      }
    },
    async savePreferences() {
      try {
        await PreferenceApi.patch(
          { bovineImport: this.preferences.bovineImport },
          this.getApiOptions()
        );
      } catch (error) {
        console.error(error);
      }
    },
    async onUpload(event) {
      try {
        if (!event.files[0]) {
          return;
        }
        this.loading = true;
        const formData = new FormData();
        formData.append(`file`, event.files[0]);
        formData.append('ignoreInactive', this.preferences.bovineImport.ignoreInactive)
        const result = await BovineApi.importParse(
          formData,
          this.getApiOptions()
        );
        this.rows = result;
        await this.savePreferences()
      } catch (error) {
        if (error?.response?.data?.error?.code === 'EmptyFile') {
          this.$toast.add({
            severity: 'warn',
            summary: 'Atenção!',
            detail: 'Não foi possível importar, o arquivo está vazio',
            life: 3000,
          });
          return;
        }
        this.$toast.add({
          severity: 'error',
          summary: 'Desculpe!',
          detail: 'Não foi possível processar esse arquivo',
          life: 3000,
        });
      } finally {
        this.loading = false;
      }
    },
    validate() {
      const invalid = this.rows.some(
        (row) => !(row.output.earring && row.output.typeId && row.output.farmId)
      );
      if (invalid) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Atenção!',
          detail:
            'Para salvar é necessário informar ao menos brinco, tipo e fazenda',
          life: 3000,
        });
        return false;
      }
      return true;
    },
    getBody() {
      const bovines = this.rows.map((row) => ({
        ...row.output,
        bullType: this.$route.query.serviceId
          ? undefined
          : row.output.bullType?.name || row.output?.bullType,
        type: undefined,
        breed: undefined,
        status: undefined,
        bovineRoot: undefined,
        farmLot: undefined,
        farm: undefined,
        owner: undefined,
        serviceBullTypeId: undefined,
        serviceBullType: this.$route.query.serviceId
          ? row.output.serviceBullType?.name || row.output?.serviceBullType
          : undefined,
      }));

      return {
        bovines,
        serviceId: Number(this.$route.query.serviceId) || undefined,
      };
    },
    async save() {
      try {
        if (!this.rows.length) {
          return;
        }
        if (!this.validate()) {
          return;
        }
        this.loading = true;
        this.loadingSave = true;

        if (this.$route.query.sale) {
          const response = await BovineApi.import(
            this.getBody(),
            this.getApiOptions()
          );
          this.$router.push({
            name: 'sale.create.bovines',
            params: {
              bovineImport: JSON.stringify(response),
            },
          });
          return;
        }

        await BovineApi.importQueue(this.getBody(), this.getApiOptions());

        if (this.$route.query.serviceId) {
          this.$router.push({
            name: 'service.edit',
            params: {
              id: this.$route.query.serviceId,
            },
          });
        } else {
          this.$router.push({ name: 'bovine.list' });
        }
      } catch (error) {
        console.log(error);
        this.$toast.add({
          severity: 'error',
          summary: 'Desculpe!',
          detail: 'Não foi possível salvar os bovinos',
          life: 3000,
        });
      } finally {
        this.loading = false;
        this.loadingSave = false;
      }
    },
  },
};
</script>

<style>
</style>